function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useCallback, useMemo, useState } from 'react';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@edusense/shared-auth-core';
// 🚀 GraphQL Mutation 사용 (REST API 제거)
import { useLikeTweet, useUnlikeTweet, useRetweet, useUndoRetweet, useDeleteTweet } from '@edusense/feed-client';
var useInternalTweetActions = function() {
    var navigate = useNavigate();
    var auth = useAuth();
    var likeMutation = useLikeTweet();
    var unlikeMutation = useUnlikeTweet();
    var retweetMutation = useRetweet();
    var undoRetweetMutation = useUndoRetweet();
    var deleteTweetMutation = useDeleteTweet();
    var ensureAuthenticated = useCallback(function() {
        var _auth_state;
        var isAuthed = typeof auth.isAuthenticated === 'function' ? auth.isAuthenticated() : Boolean((_auth_state = auth.state) === null || _auth_state === void 0 ? void 0 : _auth_state.isAuthenticated);
        if (!isAuthed) {
            toast.error('로그인이 필요합니다.');
            try {
                navigate('/auth/login');
            } catch (error) {
                console.warn('[SocialPost] navigate 호출 실패:', error);
            }
            return false;
        }
        return true;
    }, [
        auth,
        navigate
    ]);
    var normalizeTweetId = useCallback(function(rawId) {
        var trimmed = rawId === null || rawId === void 0 ? void 0 : rawId.toString().trim();
        if (!trimmed) {
            console.warn('[SocialPost] 유효하지 않은 트윗 ID:', rawId);
            return null;
        }
        return trimmed;
    }, []);
    var withAuthGuard = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(tweetId, action) {
            var normalized;
            return _ts_generator(this, function(_state) {
                normalized = normalizeTweetId(tweetId);
                if (!normalized) return [
                    2,
                    null
                ];
                if (!ensureAuthenticated()) return [
                    2,
                    null
                ];
                return [
                    2,
                    action(normalized)
                ];
            });
        });
        return function(tweetId, action) {
            return _ref.apply(this, arguments);
        };
    }(), [
        ensureAuthenticated,
        normalizeTweetId
    ]);
    return useMemo(function() {
        return {
            like: /*#__PURE__*/ function() {
                var _ref = _async_to_generator(function(tweetId) {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    withAuthGuard(tweetId, function(id) {
                                        return likeMutation.mutateAsync({
                                            tweetId: id
                                        });
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(tweetId) {
                    return _ref.apply(this, arguments);
                };
            }(),
            unlike: /*#__PURE__*/ function() {
                var _ref = _async_to_generator(function(tweetId) {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    withAuthGuard(tweetId, function(id) {
                                        return unlikeMutation.mutateAsync({
                                            tweetId: id
                                        });
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(tweetId) {
                    return _ref.apply(this, arguments);
                };
            }(),
            retweet: /*#__PURE__*/ function() {
                var _ref = _async_to_generator(function(tweetId) {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    withAuthGuard(tweetId, function(id) {
                                        return retweetMutation.mutateAsync({
                                            tweetId: id
                                        });
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(tweetId) {
                    return _ref.apply(this, arguments);
                };
            }(),
            undoRetweet: /*#__PURE__*/ function() {
                var _ref = _async_to_generator(function(tweetId) {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    withAuthGuard(tweetId, function(id) {
                                        return undoRetweetMutation.mutateAsync({
                                            tweetId: id
                                        });
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(tweetId) {
                    return _ref.apply(this, arguments);
                };
            }(),
            quote: /*#__PURE__*/ function() {
                var _ref = _async_to_generator(function(tweetId, content) {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    withAuthGuard(tweetId, /*#__PURE__*/ function() {
                                        var _ref = _async_to_generator(function(id) {
                                            return _ts_generator(this, function(_state) {
                                                try {
                                                    navigate("/microblog/compose?mode=quote&tweetId=".concat(encodeURIComponent(id)), {
                                                        state: {
                                                            content: content
                                                        },
                                                        replace: false
                                                    });
                                                } catch (error) {
                                                    console.warn('[SocialPost] quote 네비게이션 실패:', error);
                                                }
                                                return [
                                                    2,
                                                    Promise.resolve()
                                                ];
                                            });
                                        });
                                        return function(id) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(tweetId, content) {
                    return _ref.apply(this, arguments);
                };
            }(),
            deleteTweet: /*#__PURE__*/ function() {
                var _ref = _async_to_generator(function(tweetId) {
                    var result;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    withAuthGuard(tweetId, function(id) {
                                        return deleteTweetMutation.mutateAsync({
                                            tweetId: id
                                        });
                                    })
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    {
                                        success: Boolean(result)
                                    }
                                ];
                        }
                    });
                });
                return function(tweetId) {
                    return _ref.apply(this, arguments);
                };
            }(),
            reportTweet: /*#__PURE__*/ function() {
                var _ref = _async_to_generator(function(tweetId) {
                    var guarded;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    withAuthGuard(tweetId, /*#__PURE__*/ function() {
                                        var _ref = _async_to_generator(function(id) {
                                            return _ts_generator(this, function(_state) {
                                                console.warn("[SocialPost] 신고 API가 아직 연결되지 않았습니다. tweetId=".concat(id));
                                                return [
                                                    2,
                                                    null
                                                ];
                                            });
                                        });
                                        return function(id) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            case 1:
                                guarded = _state.sent();
                                return [
                                    2,
                                    {
                                        success: Boolean(guarded)
                                    }
                                ];
                        }
                    });
                });
                return function(tweetId) {
                    return _ref.apply(this, arguments);
                };
            }()
        };
    }, [
        deleteTweetMutation,
        likeMutation,
        navigate,
        retweetMutation,
        undoRetweetMutation,
        unlikeMutation,
        withAuthGuard
    ]);
};
/**
 * SocialPost 컴포넌트의 액션 핸들러를 관리하는 훅
 */ export var useSocialPostActions = function(id) {
    var initialLiked = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, initialReposted = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, onLike = arguments.length > 3 ? arguments[3] : void 0, onRepost = arguments.length > 4 ? arguments[4] : void 0, onQuote = arguments.length > 5 ? arguments[5] : void 0, onComment = arguments.length > 6 ? arguments[6] : void 0, onDeleteSuccess = arguments.length > 7 ? arguments[7] : void 0;
    var _useState = _sliced_to_array(useState(initialLiked), 2), likeState = _useState[0], setLikeState = _useState[1];
    var _useState1 = _sliced_to_array(useState(initialReposted), 2), repostState = _useState1[0], setRepostState = _useState1[1];
    var tweetActions = useInternalTweetActions();
    var handleLike = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(tweetId, isLiked) {
            var error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLikeState(isLiked);
                        if (onLike) {
                            onLike(tweetId, isLiked);
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        if (!isLiked) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            tweetActions.like(tweetId)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            tweetActions.unlike(tweetId)
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error = _state.sent();
                        console.error('[SocialPost] 좋아요 처리 중 오류:', error);
                        setLikeState(function(prev) {
                            return !prev;
                        });
                        toast.error('좋아요 처리에 실패했습니다.');
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleLike(tweetId, isLiked) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleRepost = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(tweetId) {
            var newReposted, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        newReposted = !repostState;
                        setRepostState(newReposted);
                        if (onRepost) {
                            onRepost(tweetId, newReposted);
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        if (!newReposted) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            tweetActions.retweet(tweetId)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            tweetActions.undoRetweet(tweetId)
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error = _state.sent();
                        console.error('[SocialPost] 리트윗 처리 중 오류:', error);
                        setRepostState(function(prev) {
                            return !prev;
                        });
                        toast.error('리트윗 처리에 실패했습니다.');
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleRepost(tweetId) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleQuote = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(tweetId, quoteContent) {
            var error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (onQuote) {
                            onQuote(tweetId, quoteContent);
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            tweetActions.quote(tweetId, quoteContent)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error('[SocialPost] 인용 처리 중 오류:', error);
                        toast.error('인용하기에 실패했습니다.');
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleQuote(tweetId, quoteContent) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleComment = function(tweetId) {
        if (onComment) {
            onComment(tweetId);
        }
    };
    var handleDeleteTweet = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(tweetId) {
            var result, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            tweetActions.deleteTweet(tweetId)
                        ];
                    case 1:
                        result = _state.sent();
                        if (result.success) {
                            toast.success('트윗이 삭제되었습니다.');
                            if (onDeleteSuccess) {
                                onDeleteSuccess();
                            }
                        } else {
                            toast.error('트윗 삭제에 실패했습니다.');
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        console.error('[SocialPost] 트윗 삭제 중 오류:', error);
                        toast.error('트윗 삭제 중 오류가 발생했습니다.');
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDeleteTweet(tweetId) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleReportTweet = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(tweetId) {
            var result, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            tweetActions.reportTweet(tweetId)
                        ];
                    case 1:
                        result = _state.sent();
                        if (result.success) {
                            toast.success('신고가 접수되었습니다.');
                        } else {
                            toast.error('신고 처리에 실패했습니다.');
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        console.error('[SocialPost] 트윗 신고 중 오류:', error);
                        toast.error('신고 접수에 실패했습니다.');
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleReportTweet(tweetId) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        likeState: likeState,
        repostState: repostState,
        handleLike: handleLike,
        handleRepost: handleRepost,
        handleQuote: handleQuote,
        handleComment: handleComment,
        handleDeleteTweet: handleDeleteTweet,
        handleReportTweet: handleReportTweet
    };
};
